import {
  Briefcase,
  ClipboardList,
  DollarSign,
  LayoutDashboard,
  Package,
  ShieldCheck,
  Users,
} from 'lucide-react';

export interface ModuleNavigationItem {
  key: string;
  moduleKey: string;
  label: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  matchPaths: string[];
}

export const MODULE_NAVIGATION_ITEMS: ModuleNavigationItem[] = [
  {
    key: 'gear',
    moduleKey: 'inventory',
    label: 'Gear',
    href: '/gear',
    icon: Package,
    matchPaths: [
      '/gear',
      '/gear-requests',
      '/assets',
      '/kits',
      '/deployments',
      '/reservations',
      '/maintenance',
      '/gear/compliance',
    ],
  },
  {
    key: 'safety',
    moduleKey: 'safety',
    label: 'Safe',
    href: '/safety',
    icon: ShieldCheck,
    matchPaths: ['/safety'],
  },
  {
    key: 'crew',
    moduleKey: 'crew',
    label: 'Crew',
    href: '/crew',
    icon: Users,
    matchPaths: ['/crew'],
  },
  {
    key: 'projects',
    moduleKey: 'projects',
    label: 'Books',
    href: '/projects',
    icon: Briefcase,
    matchPaths: ['/projects', '/clients'],
  },
  {
    key: 'payroll',
    moduleKey: 'payroll',
    label: 'Pay',
    href: '/payroll',
    icon: DollarSign,
    matchPaths: ['/payroll'],
  },
  {
    key: 'work',
    moduleKey: 'work',
    label: 'Project',
    href: '/work',
    icon: LayoutDashboard,
    matchPaths: ['/work', '/work/daily-reports'],
  },
  {
    key: 'compliance',
    moduleKey: 'compliance',
    label: 'Comply',
    href: '/compliance',
    icon: ClipboardList,
    matchPaths: ['/compliance'],
  },
];
